import React, { memo, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { resolveActivePolycountRange } from 'Pods/ThreeDStudio/Services/resolveActivePolycountRange'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function CollapsedPolyCountRow() {
  const t = useTranslation()
  const isDisabled = useThreeDStudioStore(state => {
    const uiSchema = state.schema.generationModelSchema.ui_schema || {}
    const { face_count: faceCountSchema, target_polycount: targetPolycountSchema } = uiSchema || {}

    return faceCountSchema?.['ui:options']?.disabled || targetPolycountSchema?.['ui:options']?.disabled
  })
  const targetPolycount = useThreeDStudioStore(state => state.modelSettings.targetPolycount)
  const polygonType = useThreeDStudioStore(state => state.modelSettings.polygonType)
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)
  const generationModelSchema = useThreeDStudioStore(state => state.schema?.generationModelSchema)

  const polyCountSchema = useMemo(
    () => resolveActivePolycountRange(generationModelSchema, { polygonType, isSmartLowPoly }),
    [generationModelSchema, polygonType, isSmartLowPoly],
  )

  const { minimum, default: defaultValue, maximum } = polyCountSchema || {}

  let presetLabel
  if (targetPolycount === minimum) {
    presetLabel = t('leftSide.polyCount.low')
  } else if (targetPolycount === defaultValue) {
    presetLabel = t('leftSide.polyCount.medium')
  } else if (targetPolycount === maximum) {
    presetLabel = t('leftSide.polyCount.high')
  }

  if (presetLabel) {
    return (
      <ClosedButtonSettings
        label={t('leftSide.polyCount.label')}
        isActive
        disabled={isDisabled}
        buttonLabel={presetLabel}
      />
    )
  }

  return (
    <div className="collapsed-model-settings__row">
      <span className="collapsed-model-settings__title">{t('leftSide.polyCount.label')}</span>
      <span className="collapsed-model-settings__numeric-value cgt-body-base">
        {targetPolycount}
      </span>
    </div>
  )
}

export default memo(CollapsedPolyCountRow)
